import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export function useE53Finalize() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fileId: number) => {
      const response = await axios.get(`/data-set/e53/finalize`, {
        params: {
          dataSet: fileId
        }
      });
      return response.data;
    },
    onSuccess: () => {
      // Invalidate relevant queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['e53Samples'] });
      queryClient.invalidateQueries({ queryKey: ['e53FileDetails'] });
    }
  });
} 